module.exports = __webpack_public_path__ + "static/media/document-type.081bf99c.svg";